import { SpotifyAuthRoute } from '../../domain/supporting/spotify';
export default SpotifyAuthRoute;
